(function () {
  function updateOptionLabelFromInput(input) {
    if (!input || !input.checked) return;
    var wrapper = input.closest(".variant-wrapper");
    if (!wrapper) return;
    var optLabel = wrapper.querySelector("[data-variant-option-label]");
    if (optLabel) optLabel.textContent = input.value;
    var caratLabel = wrapper.querySelector("[data-variant-carat-label]");
    if (caratLabel) caratLabel.textContent = input.value;
  }

  function initProductMeta(container) {
    if (!container || container.dataset.cbVariantLabelsInit === "1") return;
    container.dataset.cbVariantLabelsInit = "1";

    container.addEventListener("variantChange.product", function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !variant.options) return;
      variant.options.forEach(function (opt, i) {
        var el = container.querySelector(
          '[data-variant-option-label][data-index="' + i + '"]'
        );
        if (el) el.textContent = opt;
      });
    });

    container.querySelectorAll("[data-variant-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        updateOptionLabelFromInput(input);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll(".product-single__meta")
      .forEach(initProductMeta);
  });

  document.addEventListener("shopify:section:load", function (evt) {
    var section = evt.target;
    if (!section) return;
    section.querySelectorAll(".product-single__meta").forEach(initProductMeta);
  });
})();
